/*
 * 移动端公共方法标准化 - 客户端通信bridge
 */

import '@didi/soda-jsbridgev2'

import { getVueInstance } from '@/utils/bridge/vue-instance'
import { canOpenPageByWebUrl, isFromBDAPP } from '@/utils/bridge/fromBDAPP'
import vueI18n from '@/i18n/locale'
import store from '@/store'
import { versionSemverGte } from '@/utils/common/utils'

const DDbridge = {}

// 模拟默认bridge
DDbridge.install = function (Vue, options) {
  Vue.mixin({
    methods: {
      SodaBridge,
      SodaListener,
    },
  })
}
function getBridgeData(resp = {}) {
  const { errno = 0 } = resp
  if (errno.toString() === '0') {
    return resp.data || resp
  }
}
async function SodaBridge(methodName, param) {
  let msg = ''
  const { appVersion = '' } = store?.state?.globalParams || {}
  const GTVersion = versionSemverGte(appVersion, '1.3.2')
  // 适配逻辑处理 可根据情况省略
  switch (methodName) {
    // 收口非标准param的bridge，新bridge无参数为{},旧版存在没有参数的情况，使用'badcase'标识
    case 'getGlobalParams':
    case 'merchant.getUserInfo':
    case 'merchant.getShopInfo':
    case 'merchant.getContractorInfo':
      param = 'badcase'
      return window.SodaBridgeV2(methodName, param).then(resp => getBridgeData(resp))

    case 'setTitle':
      return new Promise(resolve => {
        setTimeout(() => {
          window.SodaBridgeV2('setTitle', param)
          resolve()
        }, 300)
      })

    case 'toggleTitleBar':
      return new Promise((resolve)=>{
        window.Soda && window.Soda.toggleTitleBar && window.Soda.toggleTitleBar(param)
        resolve()
      })
   
    case 'openPage':
      if (isFromBDAPP() && !GTVersion) {
        const url = param?.url
        if (canOpenPageByWebUrl(url)) {
          location.href = url
        } else {
          const vueInstance = getVueInstance()
          const toast = vueInstance.$createToast({
            // TODO: [BDAPP] 更新文案
            txt: vueI18n.t('Gattaran_app_wQyy_gBIH', { app: 'Explorer' }), // 此功能只能在商家端使用，{{app}}暂不支持
            type: 'correct',
          })
          toast.show()
        }
        return Promise.resolve({})
      } else {
        return window.SodaBridgeV2(methodName, param).then(resp => getBridgeData(resp))
      }
    case 'closePage':
      if (isFromBDAPP() && !GTVersion) {
        methodName = 'goBack'
      }
      return window.SodaBridgeV2(methodName, param).then(resp => getBridgeData(resp))

    case 'merchant.addPhotoBridge':
      if (isFromBDAPP()) methodName = 'manager.addPhotoBridge'
      return window.SodaBridgeV2(methodName, param).then(resp => getBridgeData(resp))
      
    case 'merchant.downloadFile':
      return window
        .SodaBridgeV2('merchant.downloadFile', param)
        .then(resp => {
          getBridgeData(resp)
          msg = vueI18n.t('FoodB_202403_tIbT_QIhv' /* 已下载成功 */)
        })
        .catch(res => {
          const { errno } = res
          if (errno === 101) {
            msg = vueI18n.t('FoodB_202403_iElx_PrgH' /* 无访问相册权限，请您开启权限后重试 */)
          } else {
            msg = vueI18n.t('FoodB_202403_Oupx_AERj' /* 下载失败，请您重试 */)
          }
        })
        .finally(() => {
          const vueInstance = getVueInstance()
          const toast = vueInstance.$createToast({
            txt: msg,
            type: 'txt',
          })
          toast.show()
        })
    default:
      return window.SodaBridgeV2(methodName, param).then(resp => getBridgeData(resp))
  }
}

function SodaListener(...args) {
  // methodName param cb OR methodName  cb
  const finalArgs = args
  const flag = finalArgs[1]
  if (finalArgs[0] === 'setBackPressListener' && !isFromBDAPP()) {
    finalArgs[1] = { listen: finalArgs[1] }
    if (flag === false) finalArgs[2] = () => {}
  }

  return window.SodaListener(...finalArgs)
  /* 使用Soda监听桥
    SodaListener('customer.onCallStateChanged', (data) => {
      console.log('customer.onCallStateChanged', data)
    })
  }
  */
}

export default {
  SodaBridge,
  SodaListener,
  ...DDbridge,
}

